export default {

  funnel_register_funnel_poe: 'New Character Campaign Funnel',

  
  // funnel_channel_expresion_poe: "Platform",
  // funnel_channel_expresion_tips_poe: 'Player login Platform',
  // funnel_channel_expresion_ann_info_poe: 'Display data results based on de-duplicated users for all platforms',


  funnel_channel_poe: "Gateway",
  funnel_channel_tips_poe: 'Player login gateway',
  funnel_channel_all_info_poe: 'Display data results based on de-duplicated users for all gateways',
  common_by_Channel_poe:'By Gateway',


  funnel_channel_language_poe: "League",
  funnel_language_expresion_poe: "The league the player is in.",
  funnel_language_all_info_poe: 'Display data results based on de-duplicated users for all leagues.',
  common_by_Language_poe:'By League',

  funnel_app_version_poe: "League Mode",
  funnel_app_version_tips_poe: "Player's league mode",
  funnel_app_version_all_info_poe: 'Display data results based on de-duplicated users for all league mode',
  funnel_by_app_version_poe:'By League Mode',

  funnel_channel_network_poe: "User Type",
  funnel_channel_network_tips_poe: "Player's system user type",
  funnel_channel_network_all_info_poe: "Display data results based on de-duplicated users for all user type",
  funnel_by_network_type_poe:'By User Type',

  funnel_channel_memory_poe: "Character Class",
  funnel_channel_memory_tips_poe: "Player's character class",
  funnel_channel_memory_all_info_poe: "Display data results based on de-duplicated users for all character class",
  funnel_by_memory_poe:'By Character Class',

  funnel_channel_step_poe: "Campaign Step",
  funnel_trends_by_step_poe: 'Trends by Campaign Step',
}